import { ChangePasswordErrorTypes } from '@griply/types';
import { mapChangePasswordError } from '@griply/utils';
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword as authUpdatePassword,
} from 'firebase/auth';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getAuthentication } from './helpers';

export const updatePassword = async (
  oldPassword: string,
  newPassword: string,
) => {
  const auth = await getAuthentication();

  if (!auth.currentUser?.email) {
    throw ChangePasswordErrorTypes.Unknown;
  }

  const credentials = EmailAuthProvider.credential(
    auth.currentUser.email,
    oldPassword,
  );

  try {
    await reauthenticateWithCredential(auth.currentUser, credentials);
    await authUpdatePassword(auth.currentUser, newPassword);
  } catch (e: unknown) {
    const code = (e as { code?: string }).code ?? '';
    const kind = mapChangePasswordError(code);
    // Wrong / weak password are the user's to fix; anything else is a bug or
    // outage we need to hear about.
    if (kind === ChangePasswordErrorTypes.Unknown) {
      getErrorReporter().captureException(e, {
        tags: { source: 'firebase-update-password' },
      });
    }
    throw kind;
  }
};
